import React, { useRef } from 'react';
import { showPmrDeleteConfirm } from '../../../utils/swalUtils';

const ConfirmationDialog = (props) => {
  const hasShownRef = useRef(false);

  React.useEffect(() => {
    if (!props.show || hasShownRef.current) {
      return;
    }

    hasShownRef.current = true;

    showPmrDeleteConfirm({
      title: props.title || 'Are you sure?',
      html: props.message
        ? `<div style="color:var(--pmr-text);font-size:16px;">${props.message}</div>`
        : undefined,
      confirmText: props.confirmText || 'Yes, delete it!',
      cancelText: props.cancelText || 'Cancel',
    })
      .then((result) => {
        hasShownRef.current = false;
        if (result.isConfirmed) {
          props.onConfirm();
        } else {
          props.handleClose?.();
        }
      })
      .catch(() => {
        hasShownRef.current = false;
      });
  }, [props.show, props.title, props.message, props.confirmText, props.cancelText, props.onConfirm, props.handleClose]);

  React.useEffect(() => {
    if (!props.show) {
      hasShownRef.current = false;
    }
  }, [props.show]);

  return null;
};

export default ConfirmationDialog;
